import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import http from 'services/http';
import { alerta } from 'components/Alert/index';

export default function SupervisorForm(props) {
    const id = props.match?.params?.id;
    const edicao = Boolean(id);

    const [nome, setNome] = useState('');
    const [opcoesGerentes, setOpcoesGerentes] = useState([]);
    const [gerentesSelecionados, setGerentesSelecionados] = useState([]);
    const [salvando, setSalvando] = useState(false);

    // Carrega os gerentes da banca para o multi-select.
    useEffect(() => {
        const carregarGerentes = async () => {
            try {
                const { data: { data: gerentes } } = await http.get('/usuarios', {
                    params: { nivel: 'gerente', resumida: true },
                });
                setOpcoesGerentes(
                    (gerentes ?? []).map((g) => ({ value: g.id, label: (g.nome ?? g.login ?? '').toUpperCase() }))
                );
            } catch (e) {
                alerta(e.response?.data ?? { success: false, message: 'Erro ao carregar gerentes.' });
            }
        };
        carregarGerentes();
    }, []);

    // Em edição, hidrata nome + gerentes vinculados.
    useEffect(() => {
        if (!edicao) return;
        const carregar = async () => {
            try {
                const { data: { data: supervisor } } = await http.get(`/supervisores/${id}`);
                setNome(supervisor.nome ?? '');
                setGerentesSelecionados(
                    (supervisor.gerentes ?? []).map((g) => ({ value: g.id, label: (g.nome ?? g.login ?? '').toUpperCase() }))
                );
            } catch (e) {
                alerta(e.response?.data ?? { success: false, message: 'Gerente não encontrado.' });
                props.history.push('/supervisores');
            }
        };
        carregar();
    }, [id, edicao]);

    const salvar = async () => {
        if (!nome.trim()) {
            alerta({ success: false, message: 'Informe o nome do gerente!' });
            return;
        }

        setSalvando(true);
        const payload = {
            nome: nome.trim(),
            gerentes: gerentesSelecionados.map((g) => g.value),
        };

        try {
            const response = edicao
                ? await http.patch(`/supervisores/${id}`, payload)
                : await http.post('/supervisores', payload);
            alerta(response.data);
            props.history.push('/supervisores');
        } catch (e) {
            alerta(e.response?.data ?? { success: false, message: 'Erro ao salvar gerente.' });
        } finally {
            setSalvando(false);
        }
    };

    return (
        <div className="bordered">
            <div>
                <div className="titulo-principal">
                    {edicao ? 'Atualizar Gerente' : 'Novo Gerente'}
                </div>

                <div className="btn-group caixa-inputs p-b">
                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">Nome:</label>
                        <input
                            required
                            type="text"
                            maxLength="120"
                            className="form-control input-dados-criar"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />
                    </div>

                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">Gerentes:</label>
                        <div style={{ flexBasis: 270, flexGrow: 1, maxWidth: 520 }}>
                            <Select
                                isMulti
                                placeholder="Selecione os gerentes..."
                                noOptionsMessage={() => 'Nenhum gerente'}
                                options={opcoesGerentes}
                                value={gerentesSelecionados}
                                onChange={(selecionados) => setGerentesSelecionados(selecionados || [])}
                            />
                        </div>
                    </div>
                </div>

                <div
                    style={{ padding: '0 10px', justifyContent: 'left' }}
                    className="d-flex m-b m-t"
                >
                    <button
                        style={{ display: 'block', width: '270px', marginLeft: '150px' }}
                        className="btn btn-success"
                        disabled={salvando}
                        onClick={salvar}
                    >
                        {salvando ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            </div>
        </div>
    );
}
